"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rating = void 0;
const lodash_1 = __importDefault(require("lodash"));
const RatingUpdateData_1 = require("./RatingUpdateData");
var Rating;
(function (Rating) {
    function create(lessonId, ownerId, value) {
        const now = Date.now();
        return {
            _id: createId(lessonId, ownerId),
            itemType: 'lesson',
            itemId: lessonId,
            createdAt: now,
            modifiedAt: now,
            ownerId,
            value,
        };
    }
    Rating.create = create;
    /** creates an in memory copy with the updated changes so we can use it for comprison */
    function update(rating, updates) {
        const cloned = lodash_1.default.cloneDeep(rating);
        const updateFields = RatingUpdateData_1.RatingUpdateData.updateFields(updates);
        lodash_1.default.forEach(updateFields, (value, field) => lodash_1.default.set(cloned, field, value));
        return cloned;
    }
    Rating.update = update;
    function createId(lessonId, userId) {
        return `${lessonId}-${userId}`;
    }
    Rating.createId = createId;
    function formatRating(n) {
        return ((n || 0) * 5).toPrecision(1);
    }
    Rating.formatRating = formatRating;
    // Howmany stars we should show for a rating
    function starCount(n) {
        return Math.round(1 + (n || 0) * 4);
    }
    Rating.starCount = starCount;
    function parseValue(value) {
        const n = lodash_1.default.isNumber(value) ? value : lodash_1.default.toNumber(value);
        return n >= 0 && n <= 1.0 ? n : undefined;
    }
    Rating.parseValue = parseValue;
})(Rating || (exports.Rating = Rating = {}));
//# sourceMappingURL=Rating.js.map